module.exports = __webpack_public_path__ + "assets/img/delete2.c09e09df.svg";